export default "__VITE_ASSET__287caa01__"